/* create by Baizhiming 2015-11-20*/
'use strict';
angular
    .module('manageConfig', ['manageCfg', 'manageConfigHeaderModule', 'logManageMentModule', 'timeShowFormatModule', 'logManageMentIframeModule'])
    .controller('manageConfigCtrl', [
        '$scope',
        '$state',
        'trsHttpService',
        'permissionService',
        'modalDialog',
        'publicToolService',
        'messagePublishService',
        function($scope, $state, trsHttpService, permissionService, modalDialog, publicToolService, messagePublishService) {
            initStatus();
            initData();

            /**
             * [initData description] 
             * @return  {[type]}  [return description]
             */
            function initData() {
                getConfigureAccessData();
                publicToolService.queryModeconfiguration('managementConfiguration');
            }
            
            /**
             * [getConfigureAccessData description]获取配置管理访问权限数据开始
             *
             * @return  {[type]}  [return description]
             */
            function getConfigureAccessData() {
                if (!angular.isDefined($scope.configureAccess)) {
                    permissionService.getPermissionData().then(
                        function(data) {
                            delete data.type; // 不需要此数据
                            data.tenant = { tenant: true }; // 增加租户管理伪权限，临时
                            // 获取模块权限，用于控制展现个模块入口
                            $scope.configureAccess = data;
                            $scope.$root.configureAccess = data;
                            // 根据模块权限来定向路由开始
                            var routerPaths = [];
                            var hasRight = false; // 是否有管理配置权限
                            // var curUrl = window.location.href; // 当前路径
                            for (var router in $scope.configureAccess) {
                                if (router === 'auth') {
                                    for (var _router in $scope.configureAccess.auth) {
                                        if (angular.isDefined($scope.status.routers[_router])) {
                                            routerPaths.push($scope.status.routers[_router]);
                                        }
                                    }
                                } else {
                                    routerPaths.push($scope.status.routers[router]);
                                }
                                hasRight = true;
                            }
                            if (hasRight) {
                                var flag = $state.current.name.split('.').length < 2;
                                if (!flag) {
                                    return;
                                }
                                // 2.0实现进入过程中，默认为第一个租户系统
                                var params = {
                                    serviceid: 'mlf_extuser',
                                    methodName: 'isAdministrator',
                                };
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                                    if (data.ISADMINISTRATOR == 'false') {
                                        var params2 = {
                                            serviceid: 'mlf_extuser',
                                            methodname: 'isTenantAdministrator'
                                        };
                                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params2, 'post').then(function(data) {
                                            if (data.ISTENANTADMINISTRATOR == 'false') {
                                                $state.go('manageconfig.' + routerPaths[0], {}, { reload: 'manageconfig' });
                                            } else {
                                                $state.go('manageconfig.tenantmanagement.basicInfoSetting', {}, { reload: 'manageconfig' });
                                            }
                                        });
                                        
                                    } else {
                                        $state.go('manageconfig.tenantmanagement.allTenantManage', {}, { reload: 'manageconfig' });
                                    }
                                });
                                // 根据模块权限来定向路由开始结束
                            } else {
                                modalDialog.alertType('您没有管理配置访问权限', '您没有管理配置访问权限', 'error', false, function() {
                                    window.close();
                                });
                            }
                        }
                    );
                }
            }
            
            /**
             * [initStatus description]获取配置管理访问权限数据结束
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    routers: {
                        role: 'rolemanage',
                        product: 'productmanage',
                        system: 'sysmanage',
                        user: 'groupmanage',
                        deptmentaldoc: 'departmentmanu',
                        log: 'logmanage',
                        tenant: 'tenantmanagement', // 增加租户管理伪权限，临时
                    },
                };
            }
            // 移动组织广播中转站
            $scope.$on('moveGroup', function(e, newLocation) {
                $scope.$broadcast('changeGroupList', true);
            });
            $scope.$on('f5', function(e, newLocation) {
                $scope.$broadcast('tenantManageMent', true);
            });

            /**
             * [goToMessageCenter description] 进入消息中心
             * @return {[type]} [description]
             */
            $scope.goToMessageCenter = function() {
                $state.go('front.mc', {}, { reload: 'front.mc' });
                $scope.currModule = 'mc';
            };
        },
    ]);
